import React from "react"

export const MissingUtilityWarning: React.FC = () => (
  <div className="tw-p-4 tw-bg-red-50 tw-border tw-border-red-200 tw-rounded-lg tw-mb-4">
    <p className="tw-text-red-800 tw-text-sm">
      * You must enter your utility information before adding your consumption
      data.
    </p>
  </div>
)

export const EmptyDataMessage: React.FC = () => (
  <div className="tw-p-4 tw-bg-yellow-50 tw-border tw-border-yellow-200 tw-rounded-lg tw-mt-4">
    <p className="tw-text-yellow-800 tw-text-sm">
      Please enter energy consumption data using &quot;Start Over&quot; or by
      clicking on the grid cells.
    </p>
  </div>
)

interface ErrorMessageProps {
  message: string
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <div className="tw-p-4 tw-bg-red-50 tw-border tw-border-red-200 tw-rounded-lg tw-mt-4">
    <p className="tw-text-red-800 tw-text-sm">{message}</p>
  </div>
)
